import { useMutation } from "@tanstack/react-query";
import services from "../services";

interface UpdateDeliveryOptionInput {
  estimateNo: string;
  splitId: string;
  optionId: string;
  payload: any;
}

export const useUpdateDeliveryOption = () => {
  return useMutation({
    mutationKey: ["deliveryOption", "update"],
    mutationFn: (data: UpdateDeliveryOptionInput) =>
      services.updateDeliveryOption(
        data.estimateNo,
        data.splitId,
        data.optionId,
        data.payload
      ),
  });
};
